<template>
  <Card :pt="BikeCardPreset">
    <template #header>
      <Skeleton width="100%" height="250px" />
    </template>
    <template #title>
      <Skeleton class="mb-2" width="70%" />

      <Skeleton shape="circle" size="2.5rem" cla />

    </template>
    <template #content>
      <div class="flex flex-col w-full">

        <Skeleton class="mb-2" width="65%" />
        <Skeleton class="mb-2" width="55%" />
        <Skeleton class="mb-2" width="75%" />
        <Skeleton class="mb-2" width="60%" />
      </div>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import Card from "primevue/card";
import BikeCardPreset from '@/presets/o2o/BikeCard'
import Skeleton from "primevue/skeleton";
</script>